import React from 'react';
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import Separator from "../elements/separator/Separator";
import { useTranslation } from "react-i18next";


const LegalNotice = () => {
    const { t } = useTranslation('enterprise');
    return (
        <>
            <SEO title="N01ZET Legal Notice" />
            <main className="page-wrapper">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" style={{height:"400px"}} data-black-overlay="1" >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner text-center">
                                    <h1 className="title display-one cust-title mt-5">{t('mentionsLegales.title')}</h1>
                                    <p className="description" style={{ fontSize: '20px' }}></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}

                {/* Start Publisher  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('mentionsLegales.contentPublisherTitle')}</h3>
                                            <p>{t('mentionsLegales.content')}</p>
                                            <p>{t('mentionsLegales.contentRegistration')}</p>
                                            <p>{t('mentionsLegales.contentAddressCompany')}</p>
                                            <p>{t('mentionsLegales.contentEmailCompany')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End Publisher  */}
                <Separator />
                {/* Start Director  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('mentionsLegales.contentPublishertitle')}</h3>
                                            <p>{t('mentionsLegales.contentPublisherName')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
                {/* End Director  */}
                <Separator />
                {/* Start Hosting  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('mentionsLegales.contentHosting')}</h3>
                                            <p>{t('mentionsLegales.contentHostingCompany')}</p>
                                            <p>{t('mentionsLegales.contentHostingRegistration')}</p>
                                            <p>{t('mentionsLegales.contentHostingAddress')}</p>
                                            <p>{t('mentionsLegales.contentHostingCountry')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div> 
                {/* End Hosting  */}

                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default LegalNotice
